<template>
    <div>
        <modal-warper target="ModalInstituicaoPessoas" :show="exibir" @close="(exibir = false)">
            <Modal id="ModalInstituicaoPessoas" :size="''" :open="exibir" :FooterDefault="false" :ClassBG="true">
                <template v-slot:header>
                    <h6 class="modal-title">Pessoas</h6>
                    <button type="button" class="btn" aria-label="Close" @click="fecharModal()">
                        <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
                    </button>
                </template>
                <template v-slot:body>
                    <div class="d-flex">
                        <div class="flex-grow-1">
                            <InputSearch v-model="filtro_text" placeholder="Pesquisar por Nome, E-mail, Departamento ou Função..." @updateSearch="reloadGrid" @keypress.enter="reloadGrid" />
                        </div>
                        <div class="ms-2">
                            <button class="btn-new-crud float-end" @click="newContatoCrud">
                                <i class="fas fa-regular fa-plus"></i><span class="ms-2">Adicionar Pessoa</span>
                            </button>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <DataTable :url_ajax="getUrlPessoasTicket()" @grid_refreshed="gridRefreshed" :refresh="refresh_grid"
                                   :filtros="filtro" method="GET" :qtd_registros_por_pagina="20" :is_table="true"
                                   :footer_fixed="true" :headers="headersModalPessoaTicket" :ajax_set_result="setPessoasTicket"
                                   :is_NotLoading="NotLoading" :="false"
                                   borderBottom="padding-left:0px;border-bottom: 1px solid grey"
                                   customHeight="max-height: calc(100vh - 14.6rem);margin-top: 0px !important;"
                                   customHeightPaginate=" max-height: calc(100vh - 17.4rem); margin-top: 0px !important;"
                                   customRowBtn="padding-left:5px" :pBtnsSlot="true" :request_api="'comercial'">
                            <template v-slot:BtnSlot="item">
                                <button class="btn-grid-editar-lista"
                                        @click="func_crud(item.row.idPessoa, item.row.idInstituicao, 'Alterar')">
                                    <i class="fas fa-pencil-alt" aria-hidden="true"></i><span class="btn-span-text">
                                        Editar
                                    </span>
                                </button>
                              
                                <button class="btn-grid-excluir-lista me-0" style="width: max-content;"
                                        @click="func_crud(item.row.idPessoa, item.row.idInstituicao, 'Excluir')" 
                                        v-if="permissoes.flAdministrador == 'Sim' || permissoes.flCadastro == 'Sim' || permissoes.flGestorNovos == 'Sim'|| permissoes.flGestorRenovacao == 'Sim'|| permissoes.flGestorSucessoCliente == 'Sim' ">
                                    <i class="fa fa-trash" aria-hidden="true">
                                    </i>
                                </button>
                            </template>
                        </DataTable>
                    </div>
                </template>
                <template v-slot:footer>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-close-clean-v2 mt-2" @click="fecharModal()">
                            Fechar
                        </button>
                    </div>
                </template>
            </Modal>
        </modal-warper>
        <modal-warper target="ContatoCrudNew" :show="isOpenModalConatoCrud" @close="(isOpenModalConatoCrud = false)">
            <ContatoCrud  :idOcorrencia="p_idOcorrencia" :idPessoa="idPessoa" modalContatoId="ContatoCrudNew" :show="isOpenModalConatoCrud" :idInstituicao="p_idInstituicao" @reloadGrid="reloadGrid" />
        </modal-warper>
        <modal-warper target="ModalConfirmacao_Pessoa_Dados_crud_delete" :show="isOpenModalConfirmacao" @close="isOpenModalConfirmacao = false">
            <ModalConfirmacao id="Pessoa_Dados_crud_delete" :title="'Excluir Pessoa'" :show="isOpenModalConfirmacao" :description="''" :red="'Deseja realmente excluir?'" :action="'Excluir Pessoa'"
                              @actionReturn="deletePessoaDados" />
        </modal-warper>
    </div>
</template>

<script>

    import axios from 'axios';
    import Modal from "@/components/App/Modal.vue";
    import ModalWarper from '@/components/App/ModalWarper.vue';
    import DataTable from '@/components/App/Datatable.vue'
    import ModalConfirmacao from '@/components/App/ModalConfirmacao.vue';
    import ContatoCrud from '@/views/Modais/InstituicaoPessoas/PessoaCrud.vue'
    import InputSearch from '@/components/App/Input_Search.vue';

    export default {
        name: "Contratos",
        emits: ['fecharModal'],
        components: {
            Modal,
            ModalWarper,
            DataTable,
            ContatoCrud,
            ModalConfirmacao,
            InputSearch
        },
        props: {
            p_exibir: {
                type: Boolean,
                default: false
            },
            p_idOcorrencia: {
                type: Number,
                default: 0
            },
            p_idInstituicao: {
                type: Number,
                default: 0
            },
            idModulo: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                idPessoa: 0,
                isOpenModalConfirmacao: false,
                isOpenModalConatoCrud: false,
                filtro_text: '',
                exibir: false,
                headersModalPessoaTicket: [
                    { class: 'col-3', name: 'nmPessoa', text: 'Nome', order: 0 },
                    { class: 'col-2', name: 'dsEmail', text: 'E-Mail', order: 0 },
                    { class: 'col-1 text-center', name: 'flAtivo', text: 'Ativo', order: 0 },
                    { class: 'col-2', name: 'nmDepartamento', text: 'Departamento', order: 0 },
                    { class: 'col-2', name: 'nmFuncao', text: 'Função', order: 0 },
                    { class: 'col', name: "btns", text: "", actions: true },
                ],
                refresh_grid: false,
                filtro: [
                    { active: true },
                ],
                NotLoading: false,
                permissoes: { flAdministrador: 'Não', flGestorNovos: 'Não', flGestorRenovacao: 'Não', flGestorSucessoCliente: 'Não', flSupervisor: 'Não' },
            };
        },
        methods: {
            deletePessoaDados() {
                let $this = this;
                axios
                    .delete(
                        process.env.VUE_APP_ROOT_COMERCIAL_API +
                        "/PessoaInstituicao/Delete?idPessoa=" +
                        $this.idPessoa + '&idInstituicao=' + $this.p_idInstituicao,
                        {
                            headers: $this.$api.getTokenComercial(),
                        }
                    )
                    .then((response) => {
                        $this.refresh_grid = true;
                    })
                    .catch((error) => {
                        var msg = "Ocorreu um erro inesperado";
                        if (error.response) {
                            if (error.response.data.erros != "") {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.$toast.show("alert", msg, true);
                    });
            },
            func_crud(idPessoa, idInstituicao, tpAlteracao) {
                let $this = this;
                $this.idPessoa = idPessoa;
                //$this.idInstituicao = idInstituicao;
                if (tpAlteracao == 'Alterar') {
                    $this.isOpenModalConatoCrud = true;
                }
                else {
                    $this.ModalConfirmacaoView = new window.bootstrap.Modal(document.getElementById('ModalConfirmacao_Pessoa_Dados_crud_delete'), {
                        keyboard: false
                    });
                    $this.ModalConfirmacaoView.show();
                }
            },
            newContatoCrud() {
                this.idPessoa = 0;
                this.isOpenModalConatoCrud = true;
            },
            fecharModal() {
                this.$emit("fecharModal", 'InstituicaoPessoas');
            },
            getUrlPessoasTicket() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/PessoaInstituicao/Get?idOcorrencia=' + $this.p_idOcorrencia + '&idInstituicao=' + $this.p_idInstituicao;
            },
            gridRefreshed(data_ajax) {
                let $this = this;
                $this.refresh_grid = false;
                $this.NotLoading = false;
            },
            reloadGrid() {
                let $this = this;
                $this.isOpenModalConatoCrud = false;
                $this.NotLoading = false;
                $this.refresh_grid = true;
            },
            setPessoasTicket(result) {
                result.forEach((value, index) => {
                    if (value.flAtivo == 'Sim') {
                        value.flAtivo = '<i class="fas fa-check icon-grid-lista-check" style="color: #34A853"></i>';
                    } else {
                        value.flAtivo = '<i class="fas fa-times icon-grid-lista-uncheck" style="color: #9F3029"></i>';
                    }
                })
                return result;
            },
            getPermissoesUsuario() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Equipe/GetPermissoesUsuarioModulo?idModulo=' + $this.idModulo, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.permissoes = response.data.data;
                })
            },
        },
        mounted() {
           
        },
        watch: {
            p_exibir(newValue, oldValue) {
                this.getPermissoesUsuario();
                this.exibir = newValue;
                this.refresh_grid = true;
            },
            filtro_text: function (newVal, oldVal) {
                let $this = this;
                $this.filtro[0].value = newVal;
            },
        },
    };
</script>
<style scoped lang="scss">
</style>
